import type { CartItem } from 'types/mafia';

interface GroupedCartItemsType {
  itemsWithFitRecommended: CartItem[];
  itemsWithFitNotRecommended: CartItem[];
  itemsWithNoRecommendationAvailable: CartItem[];
}
export const groupCartItemsBySizePrediction = (cartItems: CartItem[] = []) => {
  const groupedCartItems = cartItems.reduce(
    (acc: GroupedCartItemsType, item) => {
      if (item?.sizing?.guidance) {
        if (item.sizing.guidance.isRecommendedSize) {
          acc.itemsWithFitRecommended.push(item);
        } else {
          acc.itemsWithFitNotRecommended.push(item);
        }
      } else {
        acc.itemsWithNoRecommendationAvailable.push(item);
      }
      return acc;
    },
    {
      // Downstream-safe defaults for activeItems in cart
      itemsWithFitRecommended: [],
      itemsWithFitNotRecommended: [],
      itemsWithNoRecommendationAvailable: []
    }
  );
  return groupedCartItems;
};
